import {
  CREATED,
  FAILED,
  RUNNING,
  SUCCESS,
  TERMINATED,
  VOID,
} from '../constants';

export const getStatus = (tests = {}) => {
  const executions = Object.values(tests);

  if (executions.length === 0) {
    return null;
  }

  const statuses = new Set(executions.map(({ status }) => status));

  if (statuses.has(CREATED) || statuses.has(RUNNING)) {
    return RUNNING;
  }

  if (statuses.has(FAILED) || statuses.has(TERMINATED)) {
    return FAILED;
  }

  if (statuses.size === 1 && statuses.has(SUCCESS)) {
    return SUCCESS;
  }

  if (statuses.has(SUCCESS)) {
    return VOID;
  }

  return VOID;
};

export const getIMSI = info => {
  try {
    if (!info) return null;
    return JSON.parse(info.data).IMSI;
  } catch (error) {
    return null;
  }
};
